import React from 'react'
import useActionHook from '../../hooks/useActionHook';
import TypoCss from "./typography.module.scss";


function P1(props) {

    const {text} = props

  return (
    <p className={TypoCss.tbx_p1} >
      {text}
    </p>
  );
}

export default P1;